// extracted by mini-css-extract-plugin
export default {"container":"SingletTechField_container__g+b1p"};